import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import { App } from 'vue'

const options = {
  themes: {
    tooltip: {
      placement: 'bottom'
    },
    'tooltip-light': {
      $extend: 'tooltip',
      delay: 100,
      distance: 10,
      triggers: ['hover', 'focus', 'touch'],
      hideTriggers: () => ['click', 'hover'],
      autoHide: true
    }
  }
}

const floatingVue = {
  install(app: App) {
    app.use(FloatingVue, options)
  }
}

export default floatingVue
